import { CLASSNAME_DIALOG_GUIDANCE, CLASSNAME_DIALOG_INPUT_ROW, CLASSNAME_ERRMSG, CLASSNAME_HIDDEN, CLASSNAME_HYPERLINK_BOX } from "../view/view.class.names";
import AsyncDialog from "./asyncDialog"
import { DIALOG_RESULT_CANCEL, DIALOG_RESULT_OK } from "./dialog.constants";


const CLASS_URL_BOX = 'fv-hyperlink-url';
const CLASS_DISPLAY_BOX = 'fv-hyperlink-displaytext';
const SELECTOR_URL_BOX = '.' + CLASS_URL_BOX;

const GUIDANCE_FULL = 'To delete the link, clear the URL and Display Text fields.';
const GUIDANCE_URL_ONLY = 'To delete the link, clear the URL field.';

const makeEntrySection = (label, className, initialValue) =>
    $(`<div class="${CLASSNAME_DIALOG_INPUT_ROW}" />`)
        .append(
            $('<div />').append($('<label />').text(label)),
        )
        .append(
            $('<div />').append($(`<input type="text" class="${className}" />`).val(initialValue)),
        );

const makeUi = (url, displayText, editDisplayText) => {
    let ui = $('<div/>');

    ui.append(makeEntrySection('Link URL', CLASS_URL_BOX, url));

    if (editDisplayText) {
        ui.append(makeEntrySection('Display Text', CLASS_DISPLAY_BOX, displayText));
    }

    ui.append(
        $(`<p class="${CLASSNAME_DIALOG_GUIDANCE}" />`).text(
            editDisplayText ? GUIDANCE_FULL : GUIDANCE_URL_ONLY
        )
    );

    ui.append($(`<p class="${CLASSNAME_HIDDEN} ${CLASSNAME_ERRMSG}" />`));

    return ui[0];
};

const showError = (ui, message) => {
    const errorEl = ui.querySelector(`.${CLASSNAME_ERRMSG}`);

    errorEl.textContent = message;

    $(errorEl).removeClass(CLASSNAME_HIDDEN);
};

const showHyperlinkDialog = (url, displayText, editDisplayText) => {
    const diag = new AsyncDialog();
    const ui = makeUi(url, displayText, editDisplayText);

    diag.title = 'Set Hyperlink';
    diag.setTarget(ui);
    diag.autoFocusControl = SELECTOR_URL_BOX;
    diag.buttons = [
        {
            text: 'OK',
            allowEnter: true,
            click: () => {
                const newUrl = ui.querySelector(SELECTOR_URL_BOX).value;
                const newDisplayText = ui.querySelector(`.${CLASS_DISPLAY_BOX}`)?.value || '';

                if (newDisplayText && !newUrl) {
                    showError(ui, 'Please specify a URL or clear the display text.');
                    return;
                }

                diag.closeWithResult({
                    result: DIALOG_RESULT_OK,
                    url: newUrl,
                    displayText: newDisplayText,
                });
            },
        },
        {
            text: 'Cancel',
            click: () => {
                diag.closeWithResult({ result: DIALOG_RESULT_CANCEL });
            },
        },
    ];

    return diag.showAsync();
};

export default showHyperlinkDialog;